module.exports = __webpack_public_path__ + "media/images/common/logo_bg_11-d710a2e9e56e4859f1c3e8e6da1ce50e.png";